angular
	.module 'App.Module.CashMovementEventReason', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'cash_movement_event_reasons',
				url: '/cash_movement_event_reasons',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@cash_movement_event_reasons":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.CashMovementEventReason.Enabled'
					searchParams:
						repositoryName: 'CashMovementEventReasonRepository'
						title: 'general.cash_movement_event_reasons'
						attribute: 'reason'

			.state 'cash_movement_event_reasons.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					reason: (CashMovementEventReasonRepository, $stateParams) ->
						return CashMovementEventReasonRepository.getEntity($stateParams.id)

			.state 'cash_movement_event_reasons.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'CashMovementEventReasonController'
						controllerAs: 'vm'
						templateUrl: '@app/cash-movement-event-reason/cash-movement-event-reason.view.html'
